import { render, staticRenderFns } from "./ShokurekishoPrMessageCard.vue?vue&type=template&id=77f38f16&scoped=true"
import script from "./ShokurekishoPrMessageCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShokurekishoPrMessageCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShokurekishoPrMessageCard.vue?vue&type=style&index=0&id=77f38f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f38f16",
  null
  
)

export default component.exports